import { fleetSizeOptions } from '@helpers/selectOptions/fleetSizeOptions';
import { regionsOperateOptions } from '@helpers/selectOptions/regionsOperateOptions';
import { submitTransformKeys } from '@helpers/formHelpers/formData';
import { SiteWideDemoFormStructure } from '../siteWideDemoFormHelpers';

const siteWideDemoFormStructure: SiteWideDemoFormStructure = {
    tabs: [
        {
            sectionDescription: 'Get a demo',
            formFields: [
                {
                    id: 'first-name',
                    name: 'first_name',
                    type: 'text',
                    required: true,
                    labelKey: 'firstName',
                    placeholderKey: 'firstNamePlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'last-name',
                    name: 'last_name',
                    type: 'text',
                    required: true,
                    labelKey: 'lastName',
                    placeholderKey: 'lastNamePlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'title',
                    name: 'Title__c',
                    type: 'select',
                    labelKey: 'title',
                    placeholderKey: 'titlePlaceholder',
                    required: true,
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'user_title',
                    name: 'Title',
                    type: 'conditional-input',
                    required: false,
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'email',
                    name: 'email',
                    type: 'email',
                    required: true,
                    labelKey: 'email',
                    placeholderKey: 'emailPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'phone-number',
                    name: 'phone',
                    type: 'tel',
                    required: true,
                    labelKey: 'phone',
                    placeholderKey: 'phonePlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'self-attribution',
                    name: 'How_Did_You_Hear_About_Geotab__c',
                    type: 'select',
                    required: true,
                    optionsComponentKey: 'hearAboutUs',
                    labelKey: 'selfAttribution',
                    placeholderKey: 'selfAttributionPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'ab-name',
                    name: 'AB_name__c',
                    type: 'text',
                    hidden: true,
                    initialValue: '',
                },
                {
                    id: 'ab-treatment',
                    name: 'AB_treatment__c',
                    type: 'text',
                    hidden: true,
                    initialValue: '',
                },
            ],
            button: {
                text: 'Continue',
                type: 'button',
            },
        },
        {
            sectionDescription: 'Company details',
            formFields: [
                {
                    id: 'company',
                    name: 'company',
                    type: 'text',
                    required: true,
                    labelKey: 'company',
                    placeholderKey: 'yourCompanyPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'industry',
                    name: 'industry',
                    type: 'select',
                    required: true,
                    labelKey: 'industry',
                    placeholderKey: 'industryPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'subindustry',
                    name: 'Sub_Industry__c',
                    type: 'conditional-select',
                    required: false,
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'fleet-size',
                    name: 'fleet_size',
                    type: 'select',
                    required: true,
                    optionsArray: fleetSizeOptions,
                    labelKey: 'fleetSize',
                    placeholderKey: 'approxFleetPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'country',
                    name: 'country',
                    type: 'select',
                    required: true,
                    optionsComponentKey: 'country',
                    labelKey: 'country',
                    placeholderKey: 'countryPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'state',
                    name: 'state',
                    type: 'conditional-select',
                    required: false,
                    initialValue: '',
                    placeholderKey: 'statePlaceholder',
                    width: 6,
                },
                {
                    id: 'city',
                    name: 'city',
                    type: 'text',
                    required: true,
                    labelKey: 'city',
                    placeholderKey: 'cityPlaceholder',
                    initialValue: '',
                    width: 6,
                },
                {
                    id: 'multiple_region',
                    name: 'multiple_region_select__c',
                    type: 'multi-select-checkbox',
                    required: false,
                    optionsArray: regionsOperateOptions,
                    initialValue: [],
                    preSubmitTransform: [submitTransformKeys.JOIN_WITH_SEMI],
                    checkBoxWidth: 12,
                    forceMultiPick: true,
                    labelKey: 'multipleRegionText',
                    helperTextKey: 'forceMultiPick',
                    width: 12,
                },
                {
                    id: 'email-subscribe',
                    name: 'opt_in',
                    type: 'checkbox',
                    required: false,
                    labelKey: 'consentText',
                    initialValue: false,
                },
            ],
            button: {
                text: 'Submit',
                type: 'submit',
            },
        },
    ],
};

export default siteWideDemoFormStructure;
